<template>
  <div>

    <div style="height: 30px;display: flex;align-items: center;">
      <svg @click="back()" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path
          d="M10.9825 3.58692L10.2867 2.89111L3.85938 9.3198L10.2867 15.7478L10.9825 15.052L5.24986 9.31938L10.9825 3.58692Z"
          fill="#595959" />
      </svg>
      <span style="margin-left: 1px;margin-top: -2px;color: #595959;cursor: pointer;" @click="back()">返回</span>
      <div style="flex: 1;"></div>
      <div style="color: #EA3928;cursor: pointer;" @click="viewCompany()">整体分析</div>
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M7.79631 3.98553L8.56942 3.2124L15.7109 10.3554L8.56942 17.4976L7.79631 16.7245L14.166 10.3549L7.79631 3.98553Z" fill="#EA3928"/>
      </svg>
    </div>

    <div>

      <div style="height: 40px;padding: 5px 10px;background-color: #EA3928;color: #fff;border-top-left-radius: 6px;border-top-right-radius: 6px;">
        <div style="line-height: 40px;margin-left: 20px;font-size: 17px;">
          {{ analysisTitle }}
        </div>
      </div>

      <div style="padding: 15px;background-color: #fff;border-bottom-left-radius: 6px;border-bottom-right-radius: 6px;">
        <template v-if="viewType == 1">
          <div class="infos">
            <div v-for="(item, index) in analysisData" :key="index" class="info-item">

              <!-- 文字 -->
              <div v-if="item.type == 1">{{ item.data.strings }}</div>

              <!-- 表格 -->
              <div v-if="item.type == 2" class="analysis-table">
                <div class="analysis-table-title">{{ item.data.name }}</div>
                <table cellspacing="0">
                  <thead>
                    <tr>
                      <th v-for="(item3, index3) in item.data.head" :key="index3">{{ item3 }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item3, index3) in item.data.body" :key="index3">
                      <td v-for="(item4, index4) in item3" :key="index4">{{ item4 }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- echart图 -->
              <div v-if="item.type == 3">
                <div :id="'echarts-' + index" style="width: 100%;height: 300px;"></div>
              </div>

              <!-- 图片 -->
              <div v-if="item.type == 10">
                <div v-if="item.data.substr(0, 1) == '<'">
                  <iframe :id="'iframe-' + index" @load="changeIframe('iframe-' + index, item.data)"></iframe>
                </div>
                <img v-else :src="'data:image/png;base64,' + item.data" />
              </div>

              <!-- 表格 -->
              <div v-if="item.type == 20" class="analysis-table">
                <div v-for="(item2, index2) in item.data.chartAnalysis" :key="index2">
                  <div class="analysis-table-title">{{ item2[0].data.name }}</div>
                  <table cellspacing="0">
                    <thead>
                      <tr>
                        <th v-for="(item3, index3) in item2[0].data.head" :key="index3">{{ item3 }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item3, index3) in item2[0].data.body" :key="index3">
                        <td v-for="(item4, index4) in item3" :key="index4">{{ item4 }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- 筛选表格 -->
              <div v-if="item.type == 22">
                <div style="display: none;">
                  {{ selectIndex['index-' + index] == undefined ? $set(selectIndex, 'index-' + index, 0) : null }}
                  {{ tableData['index-' + index] == undefined ? setTableData('index-' + index, item.data) : null }}
                </div>
                <div class="select-bar">
                  <div class="select-box">
                    <template v-for="(item2, index2) in selectTimeList">
                      <div class="select-item-selected" v-if="selectIndex['index-' + index] == index2" :key="'s' + index2">
                        {{ item2 }}
                      </div>
                      <div class="select-item" v-else :key="index2"
                        @click="changeSelect('index-' + index, index2, item.data)">
                        {{ item2 }}
                      </div>
                    </template>
                  </div>
                </div>

                <div>
                  <el-table :data="tableData['index-' + index]" border style="width: 100%"
                    :header-cell-style="tableHeaderStyle">
                    <el-table-column fixed prop="subjectName" label="公告日期" width="160"></el-table-column>
                    <el-table-column v-for="(item2, index2) in tableHeadData['index-' + index]" :key="index2"
                      :prop="'data' + index2" :label="item2" width="240"></el-table-column>
                  </el-table>
                </div>
              </div>

              <!-- 数据来源 -->
              <div v-if="item.type == 32">
                <div style="padding: 10px;font-size: 14px;">
                  {{ item.data.preStrings }}
                  <span style="color: #0079d9;cursor: pointer;" @click="openUrl(item.data.url)">{{ item.data.title
                  }}</span>
                  {{ item.data.postStrings }}
                </div>
              </div>

              <!-- 表格 -->
              <div v-if="item.type == 40" class="analysis-table table-guarantee">
                <table cellspacing="0">
                  <!-- <thead>
                                  <tr>
                                    <th>{{ item.data.exGuranteeSubjectNames[0].subjectName }}</th>
                                    <th v-for="(item2, index2) in item.data.exGuranteeDates" :key="index2">{{ item2.dateValue }}</th>
                                  </tr>
                                </thead> -->
                  <tbody>
                    <tr v-for="(n, index2) in item.data.exGuranteeSubjectNames.length" :key="index2">
                      <td>{{ item.data.exGuranteeSubjectNames[index2].subjectName }}</td>
                      <template v-if="item.data.exGuranteeSubjectNames[index2].eleRank == 0">
                        <!-- 公告日期 -->
                        <td v-for="(item3, index3) in item.data.exGuranteeInfos" :key="index3">
                          {{ item3.exGuranteeInfoEle.noticeDate }}
                        </td>
                      </template>
                      <template v-if="item.data.exGuranteeSubjectNames[index2].eleRank == 1">
                        <!-- 担保方 -->
                        <td v-for="(item3, index3) in item.data.exGuranteeInfos" :key="index3">
                          {{ item3.exGuranteeInfoEle.guarName }}
                        </td>
                      </template>
                      <template v-if="item.data.exGuranteeSubjectNames[index2].eleRank == 2">
                        <!-- 被担保方 -->
                        <td v-for="(item3, index3) in item.data.exGuranteeInfos" :key="index3">
                          {{ item3.exGuranteeInfoEle.guaranteedName }}
                        </td>
                      </template>
                      <template v-if="item.data.exGuranteeSubjectNames[index2].eleRank == 3">
                        <!-- 担保方式 -->
                        <td v-for="(item3, index3) in item.data.exGuranteeInfos" :key="index3">
                          {{ item3.exGuranteeInfoEle.guaranteeWay }}
                        </td>
                      </template>
                      <template v-if="item.data.exGuranteeSubjectNames[index2].eleRank == 4">
                        <!-- 担保金额(万元) -->
                        <td v-for="(item3, index3) in item.data.exGuranteeInfos" :key="index3">
                          {{ item3.exGuranteeInfoEle.guaranteeAmt }}
                        </td>
                      </template>
                      <template v-if="item.data.exGuranteeSubjectNames[index2].eleRank == 5">
                        <!-- 币种 -->
                        <td v-for="(item3, index3) in item.data.exGuranteeInfos" :key="index3">
                          {{ item3.exGuranteeInfoEle.currency }}
                        </td>
                      </template>
                      <template v-if="item.data.exGuranteeSubjectNames[index2].eleRank == 6">
                        <!-- 担保期限(年) -->
                        <td v-for="(item3, index3) in item.data.exGuranteeInfos" :key="index3">
                          {{ item3.exGuranteeInfoEle.guaranteeExpire }}
                        </td>
                      </template>
                      <template v-if="item.data.exGuranteeSubjectNames[index2].eleRank == 7">
                        <!-- 担保起始日 -->
                        <td v-for="(item3, index3) in item.data.exGuranteeInfos" :key="index3">
                          {{ item3.exGuranteeInfoEle.guaranteeStartDate }}
                        </td>
                      </template>
                      <template v-if="item.data.exGuranteeSubjectNames[index2].eleRank == 8">
                        <!-- 担保终止日 -->
                        <td v-for="(item3, index3) in item.data.exGuranteeInfos" :key="index3">
                          {{ item3.exGuranteeInfoEle.guaranteeEndDate }}
                        </td>
                      </template>
                      <template v-if="item.data.exGuranteeSubjectNames[index2].eleRank == 9">
                        <!-- 是否履行完毕 -->
                        <td v-for="(item3, index3) in item.data.exGuranteeInfos" :key="index3">
                          {{ item3.exGuranteeInfoEle.isPerform }}
                        </td>
                      </template>
                      <template v-if="item.data.exGuranteeSubjectNames[index2].eleRank == 10">
                        <!-- 是否关联交易 -->
                        <td v-for="(item3, index3) in item.data.exGuranteeInfos" :key="index3">
                          {{ item3.exGuranteeInfoEle.isRelatedTrade }}
                        </td>
                      </template>
                      <template v-if="item.data.exGuranteeSubjectNames[index2].eleRank == 11">
                        <!-- 交易日期 -->
                        <td v-for="(item3, index3) in item.data.exGuranteeInfos" :key="index3">
                          {{ item3.exGuranteeInfoEle.tradeDate }}
                        </td>
                      </template>
                      <template v-if="item.data.exGuranteeSubjectNames[index2].eleRank == 12">
                        <!-- 担保事件说明 -->
                        <td v-for="(item3, index3) in item.data.exGuranteeInfos" :key="index3">
                          {{ item3.exGuranteeInfoEle.guarEventExplain }}
                        </td>
                      </template>
                      <template v-if="item.data.exGuranteeSubjectNames[index2].eleRank == 13">
                        <!-- 报告期 -->
                        <td v-for="(item3, index3) in item.data.exGuranteeInfos" :key="index3">
                          {{ item3.exGuranteeInfoEle.reportDate }}
                        </td>
                      </template>
                      <template v-if="item.data.exGuranteeSubjectNames[index2].eleRank == 14">
                        <!-- 报告期类别 -->
                        <td v-for="(item3, index3) in item.data.exGuranteeInfos" :key="index3">
                          {{ item3.exGuranteeInfoEle.reportTypeName }}
                        </td>
                      </template>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div
                v-if="item.type != 1 && item.type != 2 && item.type != 3 && item.type != 10 && item.type != 20 && item.type != 22 && item.type != 32 && item.type != 40">
                ----------------{{ item.type }}----------------
              </div>

            </div>
          </div>
        </template>

        <template v-if="viewType == 2">
          <el-collapse v-model="activeNames">
            <el-collapse-item v-for="(Aitem, Aindex) in analysisData.chartAnalysis" :key="Aindex"
              :title="analysisData.chartNames[Aindex]" :name="Aindex">
              <div class="infos">
                <div v-for="(item, index) in Aitem" :key="index" class="info-item">

                  <!-- 文字 -->
                  <div v-if="item.type == 1">{{ item.data.strings }}</div>

                  <!-- 表格 -->
                  <div v-if="item.type == 2" class="analysis-table">
                    <div class="analysis-table-title">{{ item.data.name }}</div>
                    <table cellspacing="0">
                      <thead>
                        <tr>
                          <th v-for="(item3, index3) in item.data.head" :key="index3">{{ item3 }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item3, index3) in item.data.body" :key="index3">
                          <td v-for="(item4, index4) in item3" :key="index4">{{ item4 }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- echart图 -->
                  <div v-if="item.type == 3">
                    <div :id="'echarts-' + Aindex + '-' + index" style="width: 100%;height: 300px;"></div>
                  </div>

                  <!-- 图片 -->
                  <div v-if="item.type == 10">
                    <div v-if="item.data.substr(0, 1) == '<'">
                      <iframe :id="'iframe-' + Aindex + '-' + index"
                        @load="changeIframe('iframe-' + Aindex + '-' + index, item.data)"></iframe>
                    </div>
                    <img v-else :src="'data:image/png;base64,' + item.data" />
                  </div>

                  <!-- 表格 -->
                  <div v-if="item.type == 20" class="analysis-table">
                    <div v-for="(item2, index2) in item.data.chartAnalysis" :key="index2">
                      <div class="analysis-table-title">{{ item2[0].data.name }}</div>
                      <table cellspacing="0">
                        <thead>
                          <tr>
                            <th v-for="(item3, index3) in item2[0].data.head" :key="index3">{{ item3
                            }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item3, index3) in item2[0].data.body" :key="index3">
                            <td v-for="(item4, index4) in item3" :key="index4">{{ item4 }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <!-- 筛选表格 -->
                  <div v-if="item.type == 22">
                    <div style="display: none;">
                      {{ selectIndex['index-' + index] == undefined ? $set(selectIndex, 'index-' + index, 0) : null }}
                      {{ tableData['index-' + index] == undefined ? setTableData('index-' + index, item.data) : null }}
                    </div>
                    <div class="select-bar">
                      <div class="select-box">
                        <template v-for="(item2, index2) in selectTimeList">
                          <div class="select-item-selected" v-if="selectIndex['index-' + index] == index2"
                            :key="'s' + index2">
                            {{ item2 }}
                          </div>
                          <div class="select-item" v-else :key="index2"
                            @click="changeSelect('index-' + index, index2, item.data)">
                            {{ item2 }}
                          </div>
                        </template>
                      </div>
                    </div>

                    <div>
                      <el-table :data="tableData['index-' + index]" border style="width: 100%"
                        :header-cell-style="tableHeaderStyle">
                        <el-table-column fixed prop="subjectName" label="公告日期" width="160"></el-table-column>
                        <el-table-column v-for="(item2, index2) in tableHeadData['index-' + index]" :key="index2"
                          :prop="'data' + index2" :label="item2" width="240"></el-table-column>
                      </el-table>
                    </div>
                  </div>

                  <!-- 数据来源 -->
                  <div v-if="item.type == 32">
                    <div style="padding: 10px;font-size: 14px;">
                      {{ item.data.preStrings }}
                      <span style="color: #0079d9;cursor: pointer;" @click="openUrl(item.data.url)">{{ item.data.title
                      }}</span>
                      {{ item.data.postStrings }}
                    </div>
                  </div>

                  <div
                    v-if="item.type != 1 && item.type != 2 && item.type != 3 && item.type != 10 && item.type != 20 && item.type != 22 && item.type != 32">
                    ----------------{{ item.type }}----------------
                  </div>

                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </template>

      </div>
    </div>

    <div style="color:#9a9a9a; padding: 5px;margin-top: 30px;">
      免责声明：上述所有信息均基于市场公开数据，经数据自动处理技术和人工智能算法产生，碧湾将尽力但不能保证其绝对准确和可靠，且亦不会承担因任何不准确或遗漏而引起的任何损失或损害的责任。所有数据信息仅供参考，不构成任何投资建议，不代表碧湾观点，投资者据此操作，风险自担。
    </div>

  </div>
</template>
      
<script>
import * as echarts from "echarts";
import { linkName } from '../../../static/js/util';

export default {
  data() {
    return {
      analysisData: '',
      analysisCompany: null,
      analysisTitle: '详情',
      viewType: 1,
      activeNames: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
      selectTimeList: ['最新', '年报', '中报', '临时公告'],
      selectIndex: {},
      tableData: {},
      tableHeadData: {}
    };
  },
  mounted() {
    this.analysisData = this.$route.query.analysisData;
    this.analysisCompany = this.$route.query.analysisCompany;
    this.analysisTitle = this.$route.query.analysisTitle;

    var dataType = Object.prototype.toString.call(this.analysisData);
    if (dataType == '[object Array]') {
      this.viewType = 1;
    } else if (dataType == '[object Object]') {
      this.viewType = 2;
    }
    //画type==3的echarts图
    setTimeout(() => {
      this.updateDraw();
    }, 300);
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    viewCompany() {
      linkName(this, 'business', {comCode: this.analysisCompany.stockCode, comName: this.analysisCompany.companyName});
    },
    //表头样式
    tableHeaderStyle() {
      var style = {
        background: '#E4E7ED',
        color: '#606266',
        border: '1px solid #DCDFE6'
      }
      return style;
    },
    //刷新echarts图
    updateDraw() {
      if (this.viewType == 1) {
        for (var i = 0; i < this.analysisData.length; i++) {
          if (this.analysisData[i].type == 3) {
            this.drawECharts('echarts-' + i, this.analysisData[i].data);
          }
        }
      } else if (this.viewType == 2) {
        for (var i = 0; i < this.analysisData.chartAnalysis.length; i++) {
          var item = this.analysisData.chartAnalysis[i];
          for (var j = 0; j < item.length; j++) {
            if (item[j].type == 3) {
              this.drawECharts('echarts-' + i + '-' + j, item[j].data);
            }
          }
        }
      }
    },
    //画echarts图
    drawECharts(idName, data) {
      // console.log(idName)
      var chartDom = document.getElementById(idName);
      var myChart = echarts.init(chartDom);
      var option = JSON.parse(data);
      option && myChart.setOption(option);
    },
    //渲染html内容
    changeIframe(idName, htmlStr) {
      // console.log(idName)
      document.getElementById(idName).contentWindow.document.children[0].innerHTML = htmlStr;
    },
    openUrl(url) {
      window.open(url);
    },
    changeSelect(name, sign, data) {
      this.selectIndex[name] = sign;
      this.setTableData(name, data);
    },
    setTableData(name, data) {

      var tableHeadDataTemp = [];
      var tableDataTemp = [];

      if (this.selectIndex[name] == 0) {
        //最新
        //表头
        for (var i = 0; i < data.slidingTableInfos.length; i++) {
          var temp = data.slidingTableInfos[i];
          tableHeadDataTemp.push(temp.reportDate);
        }
        //内容
        for (var x = 0; x < data.slidingTableSubjectNames.length; x++) {
          var tableDataRow = {};
          tableDataRow['subjectName'] = data.slidingTableSubjectNames[x].subjectName;
          var num = 0;
          for (var y = 0; y < data.slidingTableInfos.length; y++) {
            var temp = data.slidingTableInfos[y];
            tableDataRow['data' + (num++)] = temp.valueInfoEleList[x].subjectVal;
          }
          tableDataTemp.push(tableDataRow);
        }
      } else {
        var sign;
        if (this.selectIndex[name] == 1) {//年报
          sign = '0';
        } else if (this.selectIndex[name] == 2) {//中报
          sign = '2';
        } else if (this.selectIndex[name] == 3) {//临时公告
          sign = '6';
        }

        //表头
        for (var i = 0; i < data.slidingTableInfos.length; i++) {
          var temp = data.slidingTableInfos[i];
          if (temp.dateType != sign) { continue; }
          tableHeadDataTemp.push(temp.reportDate);
        }
        //内容
        for (var x = 0; x < data.slidingTableSubjectNames.length; x++) {
          var tableDataRow = {};
          tableDataRow['subjectName'] = data.slidingTableSubjectNames[x].subjectName;
          var num = 0;
          for (var y = 0; y < data.slidingTableInfos.length; y++) {
            var temp = data.slidingTableInfos[y];
            if (temp.dateType != sign) { continue; }
            tableDataRow['data' + (num++)] = temp.valueInfoEleList[x].subjectVal;
          }
          tableDataTemp.push(tableDataRow);
        }
      }

      this.$set(this.tableHeadData, name, tableHeadDataTemp);
      this.$set(this.tableData, name, tableDataTemp);
    }
  }
};
</script>
      
<style scoped>
.el-collapse-item /deep/ .el-collapse-item__header {
  font-size: 17px;
}

.info-item {
  margin-bottom: 10px;
  font-size: 16px;
}

.info-item img {
  width: 100%;
}

.info-item iframe {
  width: 100%;
  height: 405px;
}

.analysis-table table {
  width: 100%;
  text-align: center;
  border-collapse: collapse;
  border: 1px solid #9f9f9f;
}

.analysis-table table>tbody>tr,
.analysis-table table>thead>tr {
  border-top: 1px solid #9f9f9f;
  /* height: 50px; */
}

.analysis-table table>thead>tr>th {
  min-width: 75px;
}

.analysis-table-title {
  text-align: center;
  font-weight: 700;
}

.table-guarantee tr td {
  width: 11.11%;
}

.select-bar {
  padding: 5px;
}

.select-box {
  border: 1px solid #999;
  border-radius: 5px;
  display: flex;
}

.select-item {
  color: #333;
  flex: 1;
  text-align: center;
  padding: 5px 0;
  cursor: pointer;
}

.select-item-selected {
  color: #fff;
  background-color: #DA0519;
  border-radius: 4px;
  flex: 1;
  text-align: center;
  padding: 5px 0;
}</style>